const MobileCancelBottomModal = ({
  handleCancelOrder,
  setShowMoreOptions,
  showMoreOptions,
  setIsCancelModalOpen,
}) => {
  const handleClose = () => {
    setShowMoreOptions(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setShowMoreOptions(false);
      setIsCancelModalOpen(false);
    }
  };

  const handleCancelClick = () => {
    setShowMoreOptions(false);
    handleCancelOrder();
  };

  return (
    <div className="more-options-bottom-overlay" onClick={handleOverlayClick}>
      <div
        fullWidth={true}
        className="more-options-bottom"
        maxWidth="sm"
        onClose={handleClose}
      >
        <div className="cancel-option-mobile" onClick={handleCancelClick}>
          <img
            loading="lazy"
            src="https://cdn.dotpe.in/longtail/social_media_templates/7612844/DL67whIR.jpeg"
            className="cancel-option-icoon-mobile"
            alt="cancel"
            onClick={handleClose}
          />
          <div className="cancel-option-mobile-text">Cancel Order</div>
        </div>
      </div>
    </div>
  );
};

export default MobileCancelBottomModal;
